import { QuestionCircleOutlined } from "@ant-design/icons";
import { useMediaQuery } from "@mui/material";
import { Card, Tooltip, Button, Flex } from "antd";
import React from "react";

export const StatCard = ({
  title,
  description,
  action,
  style,
  children
}: {
  title: string;
  description: string;
  children: React.ReactNode;
  action?: React.ReactNode;
  style?: React.CSSProperties;
}) => {
  const verySmallScreen = useMediaQuery("(max-width: 420px)");

  return (
    <Card
      styles={{
        header: {
          padding: "0 15px",
          fontSize: verySmallScreen ? "14px" : undefined,
          fontWeight: verySmallScreen ? "500" : undefined
        },
        body: {
          padding: "1em 24px"
        }
      }}
      style={{
        ...style,
      }}
      title={
        <Flex
          style={{
            flexWrap: "wrap"
          }}
        >
          <div
            style={{
              translate: verySmallScreen ? "0 4px" : "0 2px"
            }}
          >
            {title}
          </div>
          <Tooltip title={description} >
            <Button
              type="link"
              icon={<QuestionCircleOutlined />}
            />
          </Tooltip >
          <Flex
            style={{
              marginLeft: "auto",
              height: "fit-content"
            }}
          >
            {action}
          </Flex>
        </Flex>
      }
    >
      {children}
    </Card>
  );
};
